var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9785 8.79103L0.681626 7.50196C0.486314 7.30665 0.486314 6.98634 0.681626 6.79102L6.47851 1.00195C6.67382 0.806641 6.98632 0.806641 7.18163 1.00195L12.9785 6.79102C13.1738 6.98634 13.1738 7.30665 12.9785 7.50196L11.6816 8.79103C11.4863 8.98634 11.1738 8.98634 10.9785 8.79103L6.83007 4.64258L2.68163 8.79103C2.48632 8.98634 2.17381 8.98634 1.9785 8.79103Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown1);
export default __webpack_public_path__ + "static/media/Arrow-down1.d04537e9f6d878ee51e95587a5fa369c.svg";
export { ForwardRef as ReactComponent };